import { planTypes, BILLING_CYCLE } from '@/common/constants'
import { getCartInfo } from '@/common/service/default-mapper';

/**
 * 
 * @param {Object} productItem - The product item object to map.
 * @param {string} productItem.id - The unique identifier of the product.
 * @param {string} productItem.sellerId - The unique identifier of the seller.
 * @param {string} productItem.name - The name of the product.
 * @param {string} productItem.coverImage - URL of the main product image.
 * @param {string} productItem.shortDesc - A short description of the product.
 * @param {string[]} productItem.galleryImages - An array of URLs for gallery images.
 * @param {string} productItem.unit - The unit of measurement (e.g., "device").
 * @param {string} productItem.currency - The currency code (e.g., "USD").
 * @param {string} productItem.targetAudience - The intended audience for the product.
 * @param {string[]} productItem.shortFeatures - A list of key short features.
 * @param {string[]} productItem.longFeatures - A list of detailed features.
 * @param {Array<Object>} productItem.items - List of product item variants.
 * @param {number} productItem.items[].itemMarketId - Market-specific item ID.
 * @param {number} productItem.items[].salePrice - The sale price of the item.
 * @param {number} productItem.items[].listPrice - The list/original price of the item.
 * @returns {Object} zoomLikeProductItem - The mapped object ready for cart processing.
 * @property {string} zoomLikeProductItem.type - The plan type (from planTypes).
 * @property {string} zoomLikeProductItem.typeNameKey - i18n key for the plan name.
 * @property {string} zoomLikeProductItem.planNameKey - i18n key for the plan name.
 * @property {string} zoomLikeProductItem.billing_cycle - Billing cycle (e.g., "MONTHLY", "YEARLY").
 * @property {string} zoomLikeProductItem.category - Category of the plan (usually "ZCM").
 * @property {string} zoomLikeProductItem.parent_category - Parent category (usually "ZCM").
 * @property {Object} zoomLikeProductItem.cartInfo - Cart-specific info (e.g., selected_numbers).
 * @property {number} zoomLikeProductItem.amount - Price amount.
 * @property {string} zoomLikeProductItem.plan_code - Internal plan code.
 * @property {boolean} zoomLikeProductItem.supportCoupon - Indicates if coupons are supported.
 * @property {Array} zoomLikeProductItem.dependBasePlanTypeList - List of dependent base plan types.
 * @property {Array} zoomLikeProductItem.billingCycleDependBasePlanTypeList - Billing cycle dependent base plans.
 * @property {Array} zoomLikeProductItem.licenseDependBasePlanTypeList - License dependent base plans.
 *
 */
function deskPhonesMapper(productItem) {
  if (!productItem) return null

  const {
    id,
    name,
    items
  } = productItem;

  const [firstItem] = items;
  if (!firstItem) return null

  const zoomLikeProductItem = {
    type: planTypes.DESK_PHONES,
    typeNameKey: 'billing.hw.desk_phones.addon.title',
    billing_cycle: BILLING_CYCLE.ONE_TIME,
    category: id,
    parent_category: planTypes.DESK_PHONES,
    cartInfo: getCartInfo(),
    amount: firstItem.salePrice * 100,
    plan_code: `${firstItem.itemMarketId}`,
    supportCoupon: false,
    dependBasePlanTypeList: [],
    billingCycleDependBasePlanTypeList: [],
    licenseDependBasePlanTypeList: [],
    isVendorProduct: true,
    planName: name,
    max: 50,
    list_amount: firstItem.listPrice * 100,
    __originData: productItem
  }
  return zoomLikeProductItem;
}

export default (planMap) => {
  if (
    !planMap.__vendorsData ||
    !planMap.__vendorsData.products ||
    !planMap.__vendorsData.products.length
  ) return []
  
  const vendorProducts = planMap.__vendorsData.products

  const res = vendorProducts.map(deskPhonesMapper).filter(Boolean)
  return res
}